import { SmileOutlined } from '@ant-design/icons';
import {
  Cascader,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Mentions,
  Select,
  TimePicker,
  TreeSelect,
} from 'antd';
import { useEffect, useState } from 'react';
import "../css/dashboard.css";
import imageData from "../images/alphascan.jpg";
function Dashboard(){
  const [logoClass , setLogoClass] = useState('logoLoad');
    const handleTextStatus = (e) =>{
       console.log(e,e.target.value);
    }
    const handleLoadText = (e) =>{
      console.log(e);
    }
    useEffect(() => {
      setLogoClass('logoAfterLoad')
    }, []);
    return <div class={logoClass}>
        <img src={imageData}></img>
  </div>
};
export default Dashboard;